import { render, staticRenderFns } from "./DelegationInfoDelegationTaskView.vue?vue&type=template&id=49848a3e&scoped=true&"
import script from "./DelegationInfoDelegationTaskView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoDelegationTaskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49848a3e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49848a3e')) {
      api.createRecord('49848a3e', component.options)
    } else {
      api.reload('49848a3e', component.options)
    }
    module.hot.accept("./DelegationInfoDelegationTaskView.vue?vue&type=template&id=49848a3e&scoped=true&", function () {
      api.rerender('49848a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoDelegationTaskView.vue"
export default component.exports